
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class WireframeTerrainEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const draw = () => {
            // Horizontal lines
            for (let y = y1; y <= y2; y += spacing) {
                ctx.beginPath();
                for (let x = x1; x <= x2; x += 20) {
                    const noise = Math.sin(x * 0.01 + curTime) * Math.cos(y * 0.01 + curTime) * 50 * scale;
                    if (x === x1) ctx.moveTo(x, y + noise);
                    else ctx.lineTo(x, y + noise);
                }
                ctx.stroke();
            }
            
            // Vertical lines
            for (let x = x1; x <= x2; x += spacing) {
                ctx.beginPath();
                for (let y = y1; y <= y2; y += 20) {
                    const noise = Math.sin(x * 0.01 + curTime) * Math.cos(y * 0.01 + curTime) * 50 * scale;
                    if (y === y1) ctx.moveTo(x + noise, y);
                    else ctx.lineTo(x + noise, y);
                }
                ctx.stroke();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
